import {Json} from '../../../components/JsonObjectCard';
import {RequestExample} from '../../../components/RequestExampleCard';
import {RequestDefinitionData} from "../../../components/RequestDefinition";

export const closeShortSalesOrderRequest: RequestExample = {
    title: {
        verb: 'POST',
        endpointUrl: '/api/sales-orders/:id/close-short',
    },
    curl:
        `curl --location \\
--request POST '<YOUR SERVER>/api/sales-orders/:id/close-short' \\
--header 'Authorization: Bearer <TOKEN>'
`,
};

export const closeShortSalesOrdersResponse: Json = {
    title: 'RESPONSE',
    json: {
        "id": 139,
        "number": "10159",
        "carrier": {
            "id": 3,
            "name": "UPS",
            "service": {
                "id": 4,
                "name": "3 Day Select"
            }
        },
        "fobPointName": "Origin",
        "paymentTerms": {
            "id": 1,
            "name": "COD"
        },
        "customer": {
            "id": 49,
            "name": "Discovery Bikes"
        },
        "vendorPoNumber": "",
        "customerPoNumber": "",
        "customerContact": "Discovery Bikes",
        "salesperson": {
            "id": 1,
            "name": "admin"
        },
        "deliverTo": "Discovery Bikes",
        "revisionNumber": 2,
        "lastModified": {
            "username": "admin",
            "dateLastModified": "2025-04-17T13:38:07.558-06"
        },
        "dateCreated": "2025-04-17T00:00:00.000-06",
        "dateRevision": "2025-04-17T13:35:59.444-06",
        "dateScheduled": "2025-04-17T00:00:00.000-06",
        "dateCompleted": "2025-04-17T13:38:07.230-06",
        "totalTax": "0.4",
        "totalPrice": "5.4",
        "mcTotalTax": "0.4",
        "mcTotalPrice": "5.4",
        "totalIncludesTax": false,
        "locationGroup": {
            "id": 5,
            "name": "SLC"
        },
        "note": "",
        "url": "",
        "email": "discoverysbikes@example.com",
        "phone": "801-932-1101",
        "shipToAddress": {
            "name": "Discovery Bikes",
            "street": "124 Discovery Parkway Rd",
            "city": "Anaheim",
            "state": "CA",
            "postalCode": "92801",
            "country": "UNITED STATES"
        },
        "billToAddress": {
            "name": "Discovery Bikes",
            "street": "124 Discovery Parkway",
            "city": "Anaheim",
            "state": "CA",
            "postalCode": "92801",
            "country": "UNITED STATES"
        },
        "status": "Closed Short",
        "class": {
            "id": 1,
            "name": "None"
        },
        "shipTerms": "Prepaid & Billed",
        "type": "Standard",
        "soItems": [
            {
                "id": 325,
                "product": {
                    "id": 37,
                    "name": "ACB01",
                    "description": "Accessories - Bike Bell"
                },
                "type": {
                    "id": 10,
                    "name": "Sale"
                },
                "uom": {
                    "id": 1,
                    "name": "Each",
                    "abbreviation": "ea"
                },
                "lineNumber": 1,
                "customerPartNumber": "",
                "unitPrice": "5",
                "totalTax": "0.4",
                "totalPrice": "5",
                "mcTotalTax": "0",
                "mcTotalPrice": "0",
                "taxRate": {
                    "id": 5,
                    "name": "Cal Tax",
                    "rate": 0.08
                },
                "dateLastFulfilled": "2025-04-17T13:36:37.278-06",
                "dateScheduled": "2025-04-17T13:36:00.362-06",
                "revision": "",
                "note": "",
                "status": "Fulfilled",
                "quantity": "1",
                "quantityFulfilled": "1",
                "quantityPicked": "0",
                "class": {
                    "id": 1,
                    "name": "None"
                },
                "customFields": []
            },
            {
                "id": 326,
                "product": {
                    "id": 33,
                    "name": "C202",
                    "description": "Multi Speed Chain"
                },
                "type": {
                    "id": 10,
                    "name": "Sale"
                },
                "uom": {
                    "id": 1,
                    "name": "Each",
                    "abbreviation": "ea"
                },
                "lineNumber": 2,
                "customerPartNumber": "",
                "unitPrice": "26",
                "totalTax": "0",
                "totalPrice": "0",
                "mcTotalTax": "0",
                "mcTotalPrice": "0",
                "taxRate": {
                    "id": 5,
                    "name": "Cal Tax",
                    "rate": 0.08
                },
                "dateLastFulfilled": "2025-04-17T13:38:07.158-06",
                "dateScheduled": "2025-04-17T13:36:00.461-06",
                "revision": "",
                "note": "",
                "status": "Closed Short",
                "quantity": "0",
                "quantityFulfilled": "0",
                "quantityPicked": "0",
                "class": {
                    "id": 1,
                    "name": "None"
                },
                "customFields": []
            },
            {
                "id": 327,
                "product": {
                    "id": 63,
                    "name": "CK200",
                    "description": "Alloy Multi-Speed Crankset"
                },
                "type": {
                    "id": 10,
                    "name": "Sale"
                },
                "uom": {
                    "id": 1,
                    "name": "Each",
                    "abbreviation": "ea"
                },
                "lineNumber": 3,
                "customerPartNumber": "",
                "unitPrice": "155",
                "totalTax": "0",
                "totalPrice": "0",
                "mcTotalTax": "0",
                "mcTotalPrice": "0",
                "taxRate": {
                    "id": 5,
                    "name": "Cal Tax",
                    "rate": 0.08
                },
                "dateLastFulfilled": "2025-04-17T13:38:07.191-06",
                "dateScheduled": "2025-04-17T13:36:00.516-06",
                "revision": "",
                "note": "",
                "status": "Closed Short",
                "quantity": "0",
                "quantityFulfilled": "0",
                "quantityPicked": "0",
                "class": {
                    "id": 1,
                    "name": "None"
                },
                "customFields": []
            }
        ],
        "customFields": [
            {
                "id": 20,
                "name": "Custom",
                "value": "",
                "type": "Text"
            }
        ]
    },
};

const data: RequestDefinitionData = {
    id: 'close-short-sales-order',
    title: 'Close short a sales order',
    description: 'Close short the sales order with the specified ID.',
    endpoint: {
        verb: 'POST',
        path: '/sales-orders/:id/close-short',
        tooltip: 'Close short a sales order',
    },
    attributes: [],
    requestObject: closeShortSalesOrderRequest,
    responseObject: closeShortSalesOrdersResponse,
};

export default data;
